import {ref} from "vue";
import {App, AppInfo} from '@capacitor/app';

const info = ref<AppInfo | null>({
    name: 'Moestuin',
    id: 'nl.kreekvelden.moestuin',
    build: '1',
    version: '1.0.0'
});

// Fetch once at module load, not on every composable call
App.getInfo().then(appInfo => {
    info.value = appInfo;
}).catch(() => {
    // web/dev fallback keeps the default values above
});

export function useAppInfo() {
    return info;
}
